import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Copy, Check } from 'lucide-react';
import { useSeasonal } from '../lib/useSeasonal';
import { THEMES, Bat } from '../lib/seasonalThemes';
import { Countdown } from './Countdown';

const goto = (link) => {
  const hash = link.includes('#') ? link.split('#')[1] : '';
  if (hash) document.getElementById(hash)?.scrollIntoView({ behavior: 'smooth' });
};

export const SeasonalBanner = () => {
  const s = useSeasonal();
  const [copied, setCopied] = useState(false);
  const t = THEMES[s?.theme];
  if (!t || !s.banner?.enabled) return null;
  const b = s.banner;
  const copy = () => { navigator.clipboard?.writeText(b.code).catch(() => {}); setCopied(true); setTimeout(() => setCopied(false), 1500); };
  const cls = 'btn-brand rounded-full px-6 py-3 text-[14px] font-semibold';
  const cta = b.cta_label && b.cta_link && (b.cta_link.startsWith('http')
    ? <a href={b.cta_link} target="_blank" rel="noopener noreferrer" data-testid="seasonal-banner-cta" className={cls}>{b.cta_label}</a>
    : <Link to={b.cta_link} onClick={() => goto(b.cta_link)} data-testid="seasonal-banner-cta" className={cls}>{b.cta_label}</Link>);
  return (
    <section data-testid="seasonal-banner" data-theme={s.theme} className="relative overflow-hidden text-white" style={{ backgroundColor: t.bg }}>
      <div className="absolute inset-0 opacity-70" style={{ background: t.glow }} />
      {t.moon && <>
        <div className="hidden sm:block absolute top-6 right-[8%] w-24 h-24 rounded-full bg-[#fde68a] opacity-90 shadow-[0_0_80px_20px_rgba(253,230,138,.35)]" />
        <Bat className="absolute top-10 right-[22%] w-14 text-black/80 sz-flap" />
        <Bat className="absolute top-24 right-[4%] w-9 text-black/70 sz-flap [animation-delay:-.6s]" />
      </>}
      <div className="relative max-w-7xl mx-auto px-6 py-12 md:py-14 grid md:grid-cols-[1fr_auto] items-center gap-8">
        <div className="sz-rise">
          {b.eyebrow && <div className="text-[11px] tracking-[0.35em] uppercase font-semibold" style={{ color: t.accent }}>{b.eyebrow}</div>}
          <h2 data-testid="seasonal-banner-title" className="font-serif text-4xl sm:text-5xl lg:text-6xl mt-2 leading-[1.05]">{b.title}</h2>
          {b.subtitle && <p className="mt-3 text-[15px] text-white/75 max-w-xl">{b.subtitle}</p>}
          {s.ends_at && <Countdown endsAt={s.ends_at} accent={t.accent} />}
          <div className="mt-6 flex flex-wrap items-center gap-3">
            {cta}
            {b.code && (
              <button data-testid="seasonal-banner-code" onClick={copy} style={{ color: t.accent, borderColor: t.accent }}
                className="inline-flex items-center gap-2 rounded-full border border-dashed px-5 py-3 font-mono text-[14px] tracking-widest hover:bg-white/5 transition-colors">
                {b.code} {copied ? <Check size={14} /> : <Copy size={14} />}
              </button>
            )}
          </div>
        </div>
        <div className="hidden md:block w-44 h-40 sz-bob">{t.decor}</div>
      </div>
    </section>
  );
};
